import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Tournament } from 'functions/src/types/firestore/Game/Tournament';
import { Link } from '../Link';
import { ImageOptimized } from '../image/ImageOptimized';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { GradientIcon } from '../gradients/GradientIcon';
import { GradientTypography } from '../gradients/GradientTypography';

export const BLUMINT_LOGO_URL =
  'https://firebasestorage.googleapis.com/v0/b/blumint-development.appspot.com/o/logo_transparent.png?alt=media&token=36a68473-8674-4db3-980a-c9bb9bf0ba35';

export type RegisterButtonProps = Required<
  Pick<Tournament<Date>, 'phase' | 'sponsors'>
> & { registerUrl: string; isRegistered?: boolean; isCheckedIn?: boolean };

export function RegisterButton(props: RegisterButtonProps) {
  const {
    phase,
    sponsors,
    registerUrl,
    isRegistered = false,
    isCheckedIn = false,
  } = props;
  // const { user } = useAuth();
  // const isSoloRegistered = soloUsers.find((solo) => solo.userId === user?.uid);
  // const isTeamRegistered =
  //   members.find(
  //     (member) => member.status === 'accepted' || member.status === 'captain',
  //   ) && members.find((member) => member.userId === user?.uid);

  // const registered = !!user && (isSoloRegistered || isTeamRegistered);
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {phase === 'registration' || phase === 'checkIn' ? (
        <Link href={registerUrl} sx={{ textDecoration: 'none' }}>
          {(phase === 'registration' ||
            (phase === 'checkIn' && !isRegistered)) && (
            <Button
              size="medium"
              variant="contained"
              color={isRegistered ? 'error' : 'primary'}
              sx={{
                mt: 2,
                mb: 4,
                width: '135px',
              }}
            >
              {isRegistered ? 'Unregister' : 'Register'}
            </Button>
          )}
          {phase === 'checkIn' &&
            isRegistered &&
            (isCheckedIn ? (
              <Box
                sx={{
                  display: 'flex',
                  width: '135px',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  gap: '2px',
                  mt: 2,
                }}
              >
                <GradientIcon
                  IconComponent={CheckCircleIcon}
                  gradientColor="secondary.horizontal"
                />
                <GradientTypography
                  variant="subtitle1"
                  gradientColor="secondary.vertical"
                  sx={{ textTransform: 'uppercase', fontWeight: 700 }}
                >
                  Checked In
                </GradientTypography>
              </Box>
            ) : (
              <Button
                size="medium"
                variant="contained"
                color={'warning'}
                sx={{
                  mt: 2,
                  mb: 4,
                  width: '135px',
                }}
              >
                Check In
              </Button>
            ))}
        </Link>
      ) : (
        <Box
          sx={{
            position: 'relative',
            height: '50px',
            width: '100px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ImageOptimized
            layout={'fill'}
            objectFit={'contain'}
            objectPosition={'right'}
            src={
              sponsors && sponsors[0].imgUrl
                ? sponsors[0].imgUrl
                : BLUMINT_LOGO_URL
            }
            alt={sponsors ? sponsors[0].name || 'sponsor' : 'BluMint'}
          />
        </Box>
      )}
    </Box>
  );
}
